<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item>
          <v-list-item-title>เพิ่มพนักงานในกลุ่ม</v-list-item-title>
        </v-list-item>
      </v-toolbar>
      <div class="pt-2 px-4" style="height: 100%; overflow: auto">
        <v-row>
          <v-col cols="12" lg="6">
            <label class="caption">ค้นหา</label>
            <v-text-field
              v-model="search"
              class="fix-google-chrome"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              @input="handleSearchEmployee"
              hide-details
            >
            </v-text-field
          ></v-col>
          <v-col cols="12" lg="6">
            <label class="caption">หน่วยงาน</label>
            <v-autocomplete
              v-model="organizationFilter"
              class="fix-google-chrome"
              :items="organizations"
              item-text="title_th"
              item-value="organization_uuid"
              hide-details
              outlined
              dense
              clearable
              @change="handleFilterOrganization"
            >
            </v-autocomplete
          ></v-col>
        </v-row>
        <v-row class="mt-6 mb-2">
          <v-col class="pb-0" cols="6">
            <div class="ml-4 d-inline-flex align-center">
              <input
                :disabled="pagination.isLoading || !employeesGroupMember.length"
                :indeterminate.prop="indeterminateSelectAll"
                id="selectAll"
                style="width: 18px; height: 18px"
                type="checkbox"
                :checked="checkedSelectAll"
                @input="handleSelectAll"
              />
              <label for="selectAll" class="ml-4" style="font-size: 14px">
                เลือกทั้งหมด
              </label>
            </div>
          </v-col>
          <v-col class="py-0" cols="6">
            <v-select
              class="pt-0"
              style="font-size: 14px"
              v-model="sort"
              :disabled="pagination.isLoading"
              prepend-inner-icon="mdi-sort-ascending"
              :items="sorts"
              hide-details
              @change="handleChangeSort"
            ></v-select>
          </v-col>
        </v-row>
        <DynamicScroller
          :items="employeesGroupMember"
          :min-item-size="pagination.limit"
          key-field="employee_uuid"
        >
          <template v-slot="{ item, index, active }">
            <DynamicScrollerItem
              :item="item"
              :active="active"
              :data-index="index"
            >
              <div class="py-1">
                <v-card
                  color="#f5f5f5"
                  outlined
                  class="d-flex align-center"
                  v-observe-visibility="
                    item.employee_uuid === lastEmployee.employee_uuid &&
                    !isLastPage
                      ? infiniteScrollHandler
                      : false
                  "
                >
                  <span class="pa-4">
                    <input
                      :id="item.employee_uuid"
                      :value="item.employee_uuid"
                      v-model="employeesSelected"
                      style="width: 18px; height: 18px"
                      type="checkbox"
                    />
                  </span>
                  <v-list-item two-line class="px-0">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.firstname_th }} {{ item.lastname_th }} [{{
                          item.employee_code
                        }}]
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ item.organization.title_th }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </div>
            </DynamicScrollerItem>
          </template>
        </DynamicScroller>
        <div v-if="pagination.isLoading">
          <div class="py-1">
            <v-card
              color="#f5f5f5"
              v-for="num in 2"
              :key="num"
              outlined
              class="px-4 py-2"
            >
              <Skeleton width="200px" />
              <Skeleton :count="1" />
            </v-card>
          </div>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn
            class="primary mr-3"
            :disabled="!isEmployeeGroupAddDataChange"
            depressed
            @click="onSubmit"
          >
            เพิ่มพนักงาน
          </v-btn>
          <v-btn depressed @click="handleCancel"> ยกเลิก </v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import _ from 'lodash'
import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    employeeGroup: {
      type: Object,
    },
    employeeGroupInit: {
      type: Object,
    },
  },
  watch: {
    formShow(value) {
      if (value) {
        this.employeesGroupMember = []
        this.pagination.currentPage = 1
        this.totalEmployeesGroupMember = 0
        this.getEmployeesGroupMember()
      }
    },
  },
  data() {
    return {
      employeesSelected: [],
      organizationFilter: '',
      search: '',
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: true,
      },
      employeesGroupMember: [],
      totalEmployeesGroupMember: 0,
      sort: 'firstname_th,asc',
      sorts: [
        { id: 1, text: 'เรียงตามชื่อ (ก - ฮ)', value: 'firstname_th,asc' },
        {
          id: 2,
          text: 'เรียงตามรหัส',
          value: 'employee_code,asc',
        },
        {
          id: 3,
          text: 'เรียงตามหน่วยงาน',
          value: 'organization_th,asc',
        },
      ],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    checkedSelectAll() {
      return (
        this.employeesSelected.length &&
        this.employeesSelected.length === this.totalEmployeesGroupMember
      )
    },
    indeterminateSelectAll() {
      return (
        this.employeesSelected.length &&
        this.employeesSelected.length !== this.totalEmployeesGroupMember
      )
    },
    lastEmployee() {
      const [lastItem] = this.employeesGroupMember.slice(-1)
      return lastItem || {}
    },
    isLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalEmployeesGroupMember / this.pagination.limit)
      )
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
    isEmployeeGroupAddDataChange() {
      if (this.employeesSelected.length) {
        this.$emit('isEmployeeGroupAddDataChange', true)
        return true
      }
      this.$emit('isEmployeeGroupAddDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      fetchEmployeesGroupMember: 'employeesGroup/fetchEmployeesGroupMember',
      addEmployeeGroupMember: 'employeesGroup/addEmployeeGroupMember',
      fetchEmployeeGroupById: 'employeesGroup/fetchEmployeeGroupById',
    }),
    async handleSelectAll(event) {
      try {
        const isChecked = event.target.checked
        if (isChecked) {
          if (
            this.totalEmployeesGroupMember === this.employeesGroupMember.length
          ) {
            this.employeesSelected = this.employeesGroupMember.map(
              (e) => e.employee_uuid
            )
          } else {
            this.$store.state.loading = true

            const { company_uuid } = this.$store.state.authentication.company

            const payload = {
              company_uuid,
              employee_group_uuid: this.employeeGroup.employee_group_uuid,
              params: {
                dpc: 'access-employee-group-post-delete-to-list-access-employee-group',
                organization_uuid: this.organizationFilter || undefined,
                is_active: true,
                search: this.search || undefined,
                sort: this.sort,
                is_outside_group: true,
                is_policy_tag: true,
              },
            }

            const { data: employeesGroupMember } =
              await this.fetchEmployeesGroupMember(payload)
            this.employeesSelected = employeesGroupMember.map(
              (e) => e.employee_uuid
            )
            this.$store.state.loading = false
          }
        } else {
          this.employeesSelected = []
        }
      } catch (error) {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleFilterOrganization() {
      this.employeesSelected = []
      this.employeesGroupMember = []
      this.pagination.currentPage = 1
      this.getEmployeesGroupMember()
    },
    handleSearchEmployee: _.debounce(function () {
      if (this.search === undefined || this.search === null) return
      this.employeesSelected = []
      this.employeesGroupMember = []
      this.pagination.currentPage = 1
      this.getEmployeesGroupMember()
    }, 1000),
    handleChangeSort() {
      this.employeesSelected = []
      this.employeesGroupMember = []
      this.pagination.currentPage = 1
      this.getEmployeesGroupMember()
    },
    async getEmployeesGroupMember() {
      try {
        this.pagination.isLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          employee_group_uuid: this.employeeGroup.employee_group_uuid,
          params: {
            dpc: 'access-employee-group-post-delete-to-list-access-employee-group',
            organization_uuid: this.organizationFilter || undefined,
            is_active: true,
            search: this.search || undefined,
            sort: this.sort,
            limit: `${this.pagination.limit},${
              (this.pagination.currentPage - 1) * this.pagination.limit
            }`,
            is_outside_group: true,
          },
        }
        const { total: totalEmployeesGroupMember, data: employeesGroupMember } =
          await this.fetchEmployeesGroupMember(payload)
        this.totalEmployeesGroupMember = totalEmployeesGroupMember
        this.setEmployeesGroupMember(employeesGroupMember)
        this.pagination.isLoading = false
      } catch (error) {
        this.pagination.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextEmployeesGroupMember() {
      try {
        this.pagination.currentPage += 1

        await this.getEmployeesGroupMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setEmployeesGroupMember(employeesGroupMember) {
      this.employeesGroupMember = [
        ...this.employeesGroupMember,
        ...employeesGroupMember,
      ]
    },
    infiniteScrollHandler(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextEmployeesGroupMember()
      }
    },
    async onSubmit() {
      try {
        this.search = ''
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const employee_group_uuid = this.employeeGroup.employee_group_uuid

        const payload = {
          company_uuid,
          employee_group_uuid,
          body: {
            employee_uuids: this.employeesSelected,
          },
          params: {
            dpc: 'access-employee-group-post-delete-to-list-access-employee-group',
          },
        }

        await this.addEmployeeGroupMember(payload)
        const employeeGroup = await this.fetchEmployeeGroupById({
          company_uuid,
          employee_group_uuid,
        })
        this.$store.commit('employeesGroup/EDIT_EMPLOYEE_GROUP', employeeGroup)
        this.employeesSelected = []
        this.$emit('addEmployeeGroupMemberSuccess', employeeGroup)
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'เพิ่มข้อมูลสำเร็จ',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleCancel() {
      this.employeesSelected = []
      this.$emit('onClickBlack')
    },
    handleBack() {
      if (this.isEmployeeGroupAddDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('onClickBlack')
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
      this.$emit('onClickBlack')
    },
  },
}
</script>
